module.exports = __webpack_public_path__ + "img/rules.4c3c60b1.png";